'use client';
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var isRequest = function(input) {
    return _instanceof(input, Request);
};
var isResponse = function(input) {
    return _instanceof(input, Response);
};

export { isRequest, isResponse };
